module.exports = __webpack_public_path__ + "static/media/kubernetes.ea798a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/kubernetes.png
// module id = 54
// module chunks = 0